import { render, staticRenderFns } from "./cprs-renewal-application.component.vue?vue&type=template&id=6a500fb1"
import script from "./cprs-renewal-application.component.ts?vue&type=script&lang=ts&external"
export * from "./cprs-renewal-application.component.ts?vue&type=script&lang=ts&external"
import style0 from "./cprs-renewal-application.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports